import GetStarted from "./components/Welcome";
import OnboardingFlow from "./components/OnboardingFlow";

export const steps = [
  { Component: GetStarted, key: "get-started" },
  { Component: OnboardingFlow, key: "onboarding-flow" },
];
